export const countryList = [
  {
    name: 'Singapore',
    id: 153,
    dialCode: '+65',
    wisenetCode: '5205',
  },
  {
    name: 'United Kingdom',
    id: 63,
    dialCode: '+44',
    wisenetCode: '2100',
  },
  {
    name: 'United States of America',
    id: 184,
    dialCode: '+1',
    wisenetCode: '8104',
  },
  {
    name: 'Afghanistan',
    id: 1,
    dialCode: '+93',
    wisenetCode: '7201',
  },
  {
    name: 'Albania',
    id: 3,
    dialCode: '+355',
    wisenetCode: '3201',
  },
  {
    name: 'Algeria',
    id: 50,
    dialCode: '+213',
    wisenetCode: '4101',
  },
  {
    name: 'Andorra',
    id: 4,
    dialCode: '+376',
    wisenetCode: '3101',
  },
  {
    name: 'Angola',
    id: 2,
    dialCode: '+244',
    wisenetCode: '9201',
  },
  {
    name: 'Antigua and Barbuda',
    id: 8,
    dialCode: '+1268',
    wisenetCode: '8402',
  },
  {
    name: 'Argentina',
    id: 6,
    dialCode: '+54',
    wisenetCode: '8201',
  },
  {
    name: 'Armenia',
    id: 7,
    dialCode: '+374',
    wisenetCode: '7202',
  },
  {
    name: 'Australia',
    id: 9,
    dialCode: '+61',
    wisenetCode: '1101',
  },
  {
    name: 'Austria',
    id: 10,
    dialCode: '+43',
    wisenetCode: '2301',
  },
  {
    name: 'Azerbaijan',
    id: 11,
    dialCode: '+994',
    wisenetCode: '7203',
  },
  {
    name: 'Bahamas',
    id: 19,
    dialCode: '+1242',
    wisenetCode: '8404',
  },
  {
    name: 'Bahrain',
    id: 18,
    dialCode: '+973',
    wisenetCode: '4201',
  },
  {
    name: 'Bangladesh',
    id: 16,
    dialCode: '+880',
    wisenetCode: '7101',
  },
  {
    name: 'Barbados',
    id: 25,
    dialCode: '+1246',
    wisenetCode: '8405',
  },
  {
    name: 'Belarus',
    id: 21,
    dialCode: '+375',
    wisenetCode: '3301',
  },
  {
    name: 'Belgium',
    id: 13,
    dialCode: '+32',
    wisenetCode: '2302',
  },
  {
    name: 'Belize',
    id: 22,
    dialCode: '+501',
    wisenetCode: '8301',
  },
  {
    name: 'Benin',
    id: 14,
    dialCode: '+229',
    wisenetCode: '9101',
  },
  {
    name: 'Bhutan',
    id: 27,
    dialCode: '+975',
    wisenetCode: '7102',
  },
  {
    name: 'Bolivia',
    id: 23,
    dialCode: '+591',
    wisenetCode: '8202',
  },
  {
    name: 'Bosnia and Herzegovina',
    id: 20,
    dialCode: '+387',
    wisenetCode: '3202',
  },
  {
    name: 'Botswana',
    id: 28,
    dialCode: '+267',
    wisenetCode: '9202',
  },
  {
    name: 'Brazil',
    id: 24,
    dialCode: '+55',
    wisenetCode: '8203',
  },
  {
    name: 'Brunei Darussalam',
    id: 26,
    dialCode: '+673',
    wisenetCode: '5201',
  },
  {
    name: 'Bulgaria',
    id: 17,
    dialCode: '+359',
    wisenetCode: '3203',
  },
  {
    name: 'Burkina Faso',
    id: 15,
    dialCode: '+226',
    wisenetCode: '9102',
  },
  {
    name: 'Burundi',
    id: 12,
    dialCode: '+257',
    wisenetCode: '9203',
  },
  {
    name: 'Cambodia',
    id: 92,
    dialCode: '+855',
    wisenetCode: '5102',
  },
  {
    name: 'Cameroon',
    id: 35,
    dialCode: '+237',
    wisenetCode: '9103',
  },
  {
    name: 'Canada',
    id: 30,
    dialCode: '+1',
    wisenetCode: '8102',
  },
  {
    name: 'Cape Verde',
    id: 40,
    dialCode: '+238',
    wisenetCode: '9104',
  },
  {
    name: 'Central African Republic',
    id: 29,
    dialCode: '+236',
    wisenetCode: '9105',
  },
  {
    name: 'Chad',
    id: 168,
    dialCode: '+235',
    wisenetCode: '9106',
  },
  {
    name: 'Chile',
    id: 32,
    dialCode: '+56',
    wisenetCode: '8204',
  },
  {
    name: 'China',
    id: 33,
    dialCode: '+86',
    wisenetCode: '6101',
  },
  {
    name: 'Colombia',
    id: 38,
    dialCode: '+57',
    wisenetCode: '8205',
  },
  {
    name: 'Comoros',
    id: 39,
    dialCode: '+269',
    wisenetCode: '9204',
  },
  {
    name: 'Curaçao',
    id: 10004,
    dialCode: '+599',
    wisenetCode: '',
  },
  {
    name: "People's Republic of the Congo",
    id: 37,
    dialCode: '+242',
    wisenetCode: '9107',
  },
  {
    name: 'Democratic Republic of the Congo',
    id: 36,
    dialCode: '+243',
    wisenetCode: '9108',
  },
  {
    name: 'Costa Rica',
    id: 41,
    dialCode: '+506',
    wisenetCode: '8302',
  },
  {
    name: 'Croatia',
    id: 75,
    dialCode: '+385',
    wisenetCode: '3204',
  },
  {
    name: 'Cuba',
    id: 42,
    dialCode: '+53',
    wisenetCode: '8407',
  },
  {
    name: 'Cyprus',
    id: 43,
    dialCode: '+357',
    wisenetCode: '3205',
  },
  {
    name: 'Czech Republic',
    id: 44,
    dialCode: '+420',
    wisenetCode: '3302',
  },
  {
    name: 'Denmark',
    id: 48,
    dialCode: '+45',
    wisenetCode: '2401',
  },
  {
    name: 'Djibouti',
    id: 46,
    dialCode: '+253',
    wisenetCode: '9205',
  },
  {
    name: 'Dominica',
    id: 47,
    dialCode: '+1767',
    wisenetCode: '8408',
  },
  {
    name: 'Dominican Republic',
    id: 49,
    dialCode: '+1',
    wisenetCode: '8411',
  },
  {
    name: 'Timor-Leste',
    id: 173,
    dialCode: '+670',
    wisenetCode: '5206',
  },
  {
    name: 'Ecuador',
    id: 51,
    dialCode: '+593',
    wisenetCode: '8206',
  },
  {
    name: 'Egypt',
    id: 52,
    dialCode: '+20',
    wisenetCode: '4102',
  },
  {
    name: 'El Salvador',
    id: 156,
    dialCode: '+503',
    wisenetCode: '8303',
  },
  {
    name: 'Equatorial Guinea',
    id: 69,
    dialCode: '+240',
    wisenetCode: '9112',
  },
  {
    name: 'Eritrea',
    id: 53,
    dialCode: '+291',
    wisenetCode: '9206',
  },
  {
    name: 'Estonia',
    id: 56,
    dialCode: '+372',
    wisenetCode: '3303',
  },
  {
    name: 'Ethiopia',
    id: 57,
    dialCode: '+251',
    wisenetCode: '9207',
  },
  {
    name: 'Fiji',
    id: 59,
    dialCode: '+679',
    wisenetCode: '1502',
  },
  {
    name: 'Finland',
    id: 58,
    dialCode: '+358',
    wisenetCode: '2403',
  },
  {
    name: 'France',
    id: 60,
    dialCode: '+33',
    wisenetCode: '2303',
  },
  {
    name: 'Gabon',
    id: 62,
    dialCode: '+241',
    wisenetCode: '9113',
  },
  {
    name: 'Gambia',
    id: 67,
    dialCode: '+220',
    wisenetCode: '9114',
  },
  {
    name: 'Georgia',
    id: 64,
    dialCode: '+995',
    wisenetCode: '7204',
  },
  {
    name: 'Germany',
    id: 45,
    dialCode: '+49',
    wisenetCode: '2304',
  },
  {
    name: 'Ghana',
    id: 65,
    dialCode: '+233',
    wisenetCode: '9115',
  },
  {
    name: 'Greece',
    id: 70,
    dialCode: '+30',
    wisenetCode: '3207',
  },
  {
    name: 'Grenada',
    id: 71,
    dialCode: '+1473',
    wisenetCode: '8412',
  },
  {
    name: 'Guatemala',
    id: 72,
    dialCode: '+502',
    wisenetCode: '8304',
  },
  {
    name: 'Guinea',
    id: 66,
    dialCode: '+224',
    wisenetCode: '9116',
  },
  {
    name: 'Guinea-Bissau',
    id: 68,
    dialCode: '+245',
    wisenetCode: '9117',
  },
  {
    name: 'Guyana',
    id: 73,
    dialCode: '+592',
    wisenetCode: '8211',
  },
  {
    name: 'Haiti',
    id: 76,
    dialCode: '+509',
    wisenetCode: '8414',
  },
  {
    name: 'Honduras',
    id: 74,
    dialCode: '+504',
    wisenetCode: '8305',
  },
  {
    name: 'Hong Kong',
    id: 0,
    dialCode: '+852',
    wisenetCode: '',
  },
  {
    name: 'Hungary',
    id: 77,
    dialCode: '+36',
    wisenetCode: '3304',
  },
  {
    name: 'Iceland',
    id: 83,
    dialCode: '+354',
    wisenetCode: '2405',
  },
  {
    name: 'India',
    id: 79,
    dialCode: '+91',
    wisenetCode: '7103',
  },
  {
    name: 'Indonesia',
    id: 78,
    dialCode: '+62',
    wisenetCode: '5202',
  },
  {
    name: 'Iran',
    id: 81,
    dialCode: '+98',
    wisenetCode: '4203',
  },
  {
    name: 'Iraq',
    id: 82,
    dialCode: '+964',
    wisenetCode: '4204',
  },
  {
    name: 'Ireland',
    id: 80,
    dialCode: '+353',
    wisenetCode: '2201',
  },
  {
    name: 'Israel',
    id: 84,
    dialCode: '+972',
    wisenetCode: '4205',
  },
  {
    name: 'Italy',
    id: 85,
    dialCode: '+39',
    wisenetCode: '3104',
  },
  {
    name: 'Ivory Coast',
    id: 34,
    dialCode: '+225',
    wisenetCode: '9111',
  },
  {
    name: 'Jamaica',
    id: 86,
    dialCode: '+1876',
    wisenetCode: '8415',
  },
  {
    name: 'Japan',
    id: 88,
    dialCode: '+81',
    wisenetCode: '6201',
  },
  {
    name: 'Jordan',
    id: 87,
    dialCode: '+962',
    wisenetCode: '4206',
  },
  {
    name: 'Kazakhstan',
    id: 89,
    dialCode: '+77',
    wisenetCode: '7205',
  },
  {
    name: 'Kenya',
    id: 90,
    dialCode: '+254',
    wisenetCode: '9208',
  },
  {
    name: 'Kiribati',
    id: 93,
    dialCode: '+686',
    wisenetCode: '1402',
  },
  {
    name: 'North Korea',
    id: 10001,
    dialCode: '+850',
    wisenetCode: '',
  },
  {
    name: 'South Korea',
    id: 95,
    dialCode: '+82',
    wisenetCode: '6203',
  },
  {
    name: 'Kosovo',
    id: 10002,
    dialCode: '+383',
    wisenetCode: '',
  },
  {
    name: 'Kuwait',
    id: 96,
    dialCode: '+965',
    wisenetCode: '4207',
  },
  {
    name: 'Kyrgyzstan',
    id: 91,
    dialCode: '+996',
    wisenetCode: '7206',
  },
  {
    name: 'Laos',
    id: 97,
    dialCode: '+856',
    wisenetCode: '5103',
  },
  {
    name: 'Latvia',
    id: 107,
    dialCode: '+371',
    wisenetCode: '3305',
  },
  {
    name: 'Lebanon',
    id: 98,
    dialCode: '+961',
    wisenetCode: '4208',
  },
  {
    name: 'Lesotho',
    id: 104,
    dialCode: '+266',
    wisenetCode: '9211',
  },
  {
    name: 'Liberia',
    id: 99,
    dialCode: '+231',
    wisenetCode: '9118',
  },
  {
    name: 'Libya',
    id: 100,
    dialCode: '+218',
    wisenetCode: '4103',
  },
  {
    name: 'Liechtenstein',
    id: 102,
    dialCode: '+423',
    wisenetCode: '2305',
  },
  {
    name: 'Lithuania',
    id: 105,
    dialCode: '+370',
    wisenetCode: '3306',
  },
  {
    name: 'Luxembourg',
    id: 106,
    dialCode: '+352',
    wisenetCode: '2306',
  },
  {
    name: 'North Macedonia',
    id: 115,
    dialCode: '+389',
    wisenetCode: '3206',
  },
  {
    name: 'Madagascar',
    id: 111,
    dialCode: '+261',
    wisenetCode: '9212',
  },
  {
    name: 'Malawi',
    id: 124,
    dialCode: '+265',
    wisenetCode: '9213',
  },
  {
    name: 'Malaysia',
    id: 125,
    dialCode: '+60',
    wisenetCode: '5203',
  },
  {
    name: 'Maldives',
    id: 112,
    dialCode: '+960',
    wisenetCode: '7104',
  },
  {
    name: 'Mali',
    id: 116,
    dialCode: '+223',
    wisenetCode: '9121',
  },
  {
    name: 'Malta',
    id: 117,
    dialCode: '+356',
    wisenetCode: '3105',
  },
  {
    name: 'Marshall Islands',
    id: 114,
    dialCode: '+692',
    wisenetCode: '1403',
  },
  {
    name: 'Mauritania',
    id: 122,
    dialCode: '+222',
    wisenetCode: '9122',
  },
  {
    name: 'Mauritius',
    id: 123,
    dialCode: '+230',
    wisenetCode: '9214',
  },
  {
    name: 'Mexico',
    id: 113,
    dialCode: '+52',
    wisenetCode: '8306',
  },
  {
    name: 'Micronesia',
    id: 61,
    dialCode: '+691',
    wisenetCode: '1404',
  },
  {
    name: 'Moldova',
    id: 110,
    dialCode: '+373',
    wisenetCode: '3208',
  },
  {
    name: 'Monaco',
    id: 109,
    dialCode: '+377',
    wisenetCode: '2307',
  },
  {
    name: 'Mongolia',
    id: 120,
    dialCode: '+976',
    wisenetCode: '6104',
  },
  {
    name: 'Montenegro',
    id: 119,
    dialCode: '+382',
    wisenetCode: '3214',
  },
  {
    name: 'Morocco',
    id: 108,
    dialCode: '+212',
    wisenetCode: '4104',
  },
  {
    name: 'Mozambique',
    id: 121,
    dialCode: '+258',
    wisenetCode: '9216',
  },
  {
    name: 'Myanmar (Burma)',
    id: 118,
    dialCode: '+95',
    wisenetCode: '5101',
  },
  {
    name: 'Namibia',
    id: 126,
    dialCode: '+264',
    wisenetCode: '9217',
  },
  {
    name: 'Nauru',
    id: 133,
    dialCode: '+674',
    wisenetCode: '1405',
  },
  {
    name: 'Nepal',
    id: 132,
    dialCode: '+977',
    wisenetCode: '7105',
  },
  {
    name: 'Netherlands',
    id: 130,
    dialCode: '+31',
    wisenetCode: '2308',
  },
  {
    name: 'New Zealand',
    id: 134,
    dialCode: '+64',
    wisenetCode: '1201',
  },
  {
    name: 'Nicaragua',
    id: 129,
    dialCode: '+505',
    wisenetCode: '8307',
  },
  {
    name: 'Niger',
    id: 127,
    dialCode: '+227',
    wisenetCode: '9123',
  },
  {
    name: 'Nigeria',
    id: 128,
    dialCode: '+234',
    wisenetCode: '9124',
  },
  {
    name: 'Norway',
    id: 131,
    dialCode: '+47',
    wisenetCode: '2406',
  },
  {
    name: 'Oman',
    id: 135,
    dialCode: '+968',
    wisenetCode: '4211',
  },
  {
    name: 'Pakistan',
    id: 136,
    dialCode: '+92',
    wisenetCode: '7106',
  },
  {
    name: 'Palau',
    id: 140,
    dialCode: '+680',
    wisenetCode: '1407',
  },
  {
    name: 'Palestine',
    id: 10003,
    dialCode: '+970',
    wisenetCode: '',
  },
  {
    name: 'Panama',
    id: 137,
    dialCode: '+507',
    wisenetCode: '8308',
  },
  {
    name: 'Papua New Guinea',
    id: 141,
    dialCode: '+675',
    wisenetCode: '1302',
  },
  {
    name: 'Paraguay',
    id: 144,
    dialCode: '+595',
    wisenetCode: '8212',
  },
  {
    name: 'Peru',
    id: 138,
    dialCode: '+51',
    wisenetCode: '8213',
  },
  {
    name: 'Philippines',
    id: 139,
    dialCode: '+63',
    wisenetCode: '5204',
  },
  {
    name: 'Poland',
    id: 142,
    dialCode: '+48',
    wisenetCode: '3307',
  },
  {
    name: 'Portugal',
    id: 143,
    dialCode: '+351',
    wisenetCode: '3106',
  },
  {
    name: 'Qatar',
    id: 146,
    dialCode: '+974',
    wisenetCode: '4212',
  },
  {
    name: 'Romania',
    id: 147,
    dialCode: '+40',
    wisenetCode: '3211',
  },
  {
    name: 'Russia',
    id: 148,
    dialCode: '+7',
    wisenetCode: '3308',
  },
  {
    name: 'Rwanda',
    id: 149,
    dialCode: '+250',
    wisenetCode: '9221',
  },
  {
    name: 'Saint Kitts and Nevis',
    id: 94,
    dialCode: '+1869',
    wisenetCode: '8422',
  },
  {
    name: 'Saint Lucia',
    id: 101,
    dialCode: '+1758',
    wisenetCode: '8423',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    id: 187,
    dialCode: '+1784',
    wisenetCode: '8424',
  },
  {
    name: 'Samoa',
    id: 191,
    dialCode: '+685',
    wisenetCode: '1505',
  },
  {
    name: 'San Marino',
    id: 157,
    dialCode: '+378',
    wisenetCode: '3107',
  },
  {
    name: 'Sao Tomé and Principe',
    id: 160,
    dialCode: '+239',
    wisenetCode: '9125',
  },
  {
    name: 'Saudi Arabia',
    id: 150,
    dialCode: '+966',
    wisenetCode: '4213',
  },
  {
    name: 'Senegal',
    id: 152,
    dialCode: '+221',
    wisenetCode: '9126',
  },
  {
    name: 'Serbia',
    id: 159,
    dialCode: '+381',
    wisenetCode: '3215',
  },
  {
    name: 'Seychelles',
    id: 166,
    dialCode: '+248',
    wisenetCode: '9223',
  },
  {
    name: 'Sierra Leone',
    id: 155,
    dialCode: '+232',
    wisenetCode: '9127',
  },
  {
    name: 'Slovakia',
    id: 162,
    dialCode: '+421',
    wisenetCode: '3311',
  },
  {
    name: 'Slovenia',
    id: 163,
    dialCode: '+386',
    wisenetCode: '3212',
  },
  {
    name: 'Solomon Islands',
    id: 154,
    dialCode: '+677',
    wisenetCode: '1303',
  },
  {
    name: 'Somalia',
    id: 158,
    dialCode: '+252',
    wisenetCode: '9224',
  },
  {
    name: 'South Africa',
    id: 193,
    dialCode: '+27',
    wisenetCode: '9225',
  },
  {
    name: 'South Sudan',
    id: 197,
    dialCode: '+211',
    wisenetCode: '4111',
  },
  {
    name: 'Spain',
    id: 55,
    dialCode: '+34',
    wisenetCode: '3108',
  },
  {
    name: 'Sri Lanka',
    id: 103,
    dialCode: '+94',
    wisenetCode: '7107',
  },
  {
    name: 'Sudan',
    id: 151,
    dialCode: '+249',
    wisenetCode: '4105',
  },
  {
    name: 'Suriname',
    id: 161,
    dialCode: '+597',
    wisenetCode: '8214',
  },
  {
    name: 'Swaziland',
    id: 165,
    dialCode: '+268',
    wisenetCode: '9226',
  },
  {
    name: 'Sweden',
    id: 164,
    dialCode: '+46',
    wisenetCode: '2407',
  },
  {
    name: 'Switzerland',
    id: 31,
    dialCode: '+41',
    wisenetCode: '2311',
  },
  {
    name: 'Syrian Arab Republic',
    id: 167,
    dialCode: '+963',
    wisenetCode: '4214',
  },
  {
    name: 'Taiwan',
    id: 179,
    dialCode: '+886',
    wisenetCode: '6105',
  },
  {
    name: 'Tajikistan',
    id: 171,
    dialCode: '+992',
    wisenetCode: '7207',
  },
  {
    name: 'Tanzania',
    id: 180,
    dialCode: '+255',
    wisenetCode: '9227',
  },
  {
    name: 'Thailand',
    id: 170,
    dialCode: '+66',
    wisenetCode: '5104',
  },
  {
    name: 'Togo',
    id: 169,
    dialCode: '+228',
    wisenetCode: '9128',
  },
  {
    name: 'Tonga',
    id: 174,
    dialCode: '+676',
    wisenetCode: '1508',
  },
  {
    name: 'Trinidad and Tobago',
    id: 175,
    dialCode: '+1868',
    wisenetCode: '8425',
  },
  {
    name: 'Tunisia',
    id: 176,
    dialCode: '+216',
    wisenetCode: '4106',
  },
  {
    name: 'Turkey',
    id: 177,
    dialCode: '+90',
    wisenetCode: '4215',
  },
  {
    name: 'Turkmenistan',
    id: 172,
    dialCode: '+993',
    wisenetCode: '7208',
  },
  {
    name: 'Tuvalu',
    id: 178,
    dialCode: '+688',
    wisenetCode: '1511',
  },
  {
    name: 'Uganda',
    id: 181,
    dialCode: '+256',
    wisenetCode: '9228',
  },
  {
    name: 'Ukraine',
    id: 182,
    dialCode: '+380',
    wisenetCode: '3312',
  },
  {
    name: 'United Arab Emirates',
    id: 5,
    dialCode: '+971',
    wisenetCode: '4216',
  },
  {
    name: 'Uruguay',
    id: 183,
    dialCode: '+598',
    wisenetCode: '8215',
  },
  {
    name: 'Uzbekistan',
    id: 185,
    dialCode: '+998',
    wisenetCode: '7211',
  },
  {
    name: 'Vanuatu',
    id: 190,
    dialCode: '+678',
    wisenetCode: '1304',
  },
  {
    name: 'Vatican City',
    id: 186,
    dialCode: '+379',
    wisenetCode: '3103',
  },
  {
    name: 'Venezuela',
    id: 188,
    dialCode: '+58',
    wisenetCode: '8216',
  },
  {
    name: 'Vietnam',
    id: 189,
    dialCode: '+84',
    wisenetCode: '5105',
  },
  {
    name: 'Yemen',
    id: 192,
    dialCode: '+967',
    wisenetCode: '4217',
  },
  {
    name: 'Zambia',
    id: 194,
    dialCode: '+260',
    wisenetCode: '9231',
  },
  {
    name: 'Zimbabwe',
    id: 195,
    dialCode: '+263',
    wisenetCode: '9232',
  },
];
